<app-modal [isOpen]="isOpen" [className]="'max-w-7xl p-6 sm:p-8'" (close)="closeModal()">

    <!-- HEADER -->
    <div class="mb-6 flex items-start justify-between gap-4">
        <div>
            <h3 class="text-xl font-semibold text-gray-800 dark:text-white/90">
                {{ isViewMode ? ('Detalle de venta' + (selectedSale?.id != null ? ' #' + selectedSale!.id : '')) : 'Registro de Venta' }}
            </h3>
            <p class="text-sm text-gray-500">
                {{ isViewMode ? 'Información de la venta registrada.' : 'Selecciona cliente, agrega productos/servicios y finaliza la venta.' }}
            </p>
        </div>

        <div class="flex items-center gap-4 flex-shrink-0 mr-15">
            @if (loadingDetail) {
            <span class="text-sm text-gray-400 animate-pulse">Cargando datos…</span>
            }

            @if (!isViewMode) {
            <!-- Currency slider + tipo de cambio -->
            <div class="flex items-center gap-3 select-none flex-wrap">
                <div class="flex items-center gap-2">
                    <span class="text-sm font-medium" [class.text-brand-600]="currencyCode === 'PEN'" [class.dark:text-brand-400]="currencyCode === 'PEN'" [class.text-gray-400]="currencyCode !== 'PEN'">Soles</span>
                    <button type="button"
                        class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none"
                        [class.bg-brand-500]="currencyCode === 'USD'"
                        [class.bg-gray-300]="currencyCode !== 'USD'"
                        [class.dark:bg-gray-600]="currencyCode !== 'USD'"
                        (click)="currencyCode = currencyCode === 'PEN' ? 'USD' : 'PEN'; onCurrencyChange()">
                        <span class="inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform"
                            [class.translate-x-6]="currencyCode === 'USD'"
                            [class.translate-x-1]="currencyCode !== 'USD'">
                        </span>
                    </button>
                    <span class="text-sm font-medium" [class.text-brand-600]="currencyCode === 'USD'" [class.dark:text-brand-400]="currencyCode === 'USD'" [class.text-gray-400]="currencyCode !== 'USD'">Dólares</span>
                </div>
                @if (exchangeRateSale > 0) {
                <span class="text-sm text-gray-400 dark:text-gray-500">Tipo Cambio: {{ exchangeRateSale | number:'1.3-3' }}</span>
                }
            </div>
            }
        </div>
    </div>

    <div class="grid grid-cols-1 gap-6 lg:grid-cols-4">

        <!-- ========================================================= -->
        <!-- IZQUIERDA (DETALLE) -->
        <!-- ========================================================= -->
        <div class="lg:col-span-3 space-y-6">

            <!-- ================= CLIENTE ================= -->
            <div
                class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/[0.03]">
                <div class="flex items-center justify-between mb-4">
                    <h4 class="text-base font-semibold text-gray-800 dark:text-white/90">
                        Cliente
                    </h4>

                    @if (!isViewMode) {
                    <div class="flex gap-2">
                        <button type="button"
                            class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-brand-600 transition-colors"
                            (click)="openClientModal()">
                            <svg width="16" height="16" viewBox="0 0 20 20" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M3.04199 9.37381C3.04199 5.87712 5.87735 3.04218 9.37533 3.04218C12.8733 3.04218 15.7087 5.87712 15.7087 9.37381C15.7087 12.8705 12.8733 15.7055 9.37533 15.7055C5.87735 15.7055 3.04199 12.8705 3.04199 9.37381ZM9.37533 1.54218C5.04926 1.54218 1.54199 5.04835 1.54199 9.37381C1.54199 13.6993 5.04926 17.2055 9.37533 17.2055C11.2676 17.2055 13.0032 16.5346 14.3572 15.4178L17.1773 18.2381C17.4702 18.531 17.945 18.5311 18.2379 18.2382C18.5308 17.9453 18.5309 17.4704 18.238 17.1775L15.4182 14.3575C16.5367 13.0035 17.2087 11.2671 17.2087 9.37381C17.2087 5.04835 13.7014 1.54218 9.37533 1.54218Z"
                                    fill="white" />
                            </svg>
                            Buscar
                        </button>

                        <button type="button"
                            class="rounded-lg border border-gray-300 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800 transition-colors"
                            (click)="clearClient()">
                            Limpiar
                        </button>
                    </div>
                    }

                </div>

                <div
                    class="rounded-lg border border-dashed border-gray-300 p-3 text-sm text-gray-600 dark:border-gray-700 dark:text-white/90">
                    @if (!selectedClient) {
                    <span>Sin cliente seleccionado</span>
                    } @else {
                    <div>
                        <p class="font-medium text-gray-800 dark:text-white flex items-center gap-2">
                            {{ getClientDisplay(selectedClient) }}
                            @if (selectedClient!.retentionAgent) {
                            <span class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400">
                                Ag. Retención
                            </span>
                            }
                        </p>
                        <p class="text-xs text-gray-500">
                            {{ selectedClient!.documentType }}: {{ selectedClient!.documentNumber }}
                        </p>
                    </div>
                    }
                </div>

                <!-- ADDRESS SELECTION -->
                @if (selectedClient && !isViewMode) {
                <div class="mt-3">
                    <p class="mb-2 text-xs font-medium text-gray-500 dark:text-gray-400">Dirección <span class="text-error-500">*</span></p>

                    @if (selectedClient.addresses?.length) {
                    <!-- Registered address chips -->
                    <div class="mb-2 flex flex-wrap gap-1.5">
                        @for (a of selectedClient.addresses; track a.id) {
                        <button type="button"
                            (click)="selectClientAddress(a.id, a.address)"
                            class="inline-flex max-w-xs items-center truncate rounded-full border px-3 py-1 text-xs font-medium transition-colors"
                            [ngClass]="selectedClientAddressId === a.id
                                ? 'border-brand-500 bg-brand-50 text-brand-700 dark:border-brand-400 dark:bg-brand-500/10 dark:text-brand-300'
                                : 'border-gray-300 bg-white text-gray-600 hover:border-gray-400 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-400 dark:hover:border-gray-600'">
                            {{ a.address }}
                            @if (a.description) {
                            <span class="ml-1 text-gray-400 dark:text-gray-500">· {{ a.description }}</span>
                            }
                        </button>
                        }
                        <!-- Custom address chip -->
                        <button type="button"
                            (click)="selectedClientAddressId = null; clientAddress = ''"
                            class="inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium transition-colors"
                            [ngClass]="selectedClientAddressId === null
                                ? 'border-brand-500 bg-brand-50 text-brand-700 dark:border-brand-400 dark:bg-brand-500/10 dark:text-brand-300'
                                : 'border-gray-300 bg-white text-gray-600 hover:border-gray-400 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-400 dark:hover:border-gray-600'">
                            <svg class="mr-1 h-3 w-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
                            </svg>
                            Otra dirección
                        </button>
                    </div>
                    }

                    <!-- Address text input: always shown if no registered addresses, or if "Otra dirección" selected -->
                    @if (!selectedClient.addresses?.length || selectedClientAddressId === null) {
                    <input type="text" [(ngModel)]="clientAddress" name="clientAddress"
                        (ngModelChange)="onClientAddressInputChange($event)"
                        placeholder="Ingrese la dirección del cliente"
                        class="h-9 w-full rounded-lg border border-gray-300 bg-transparent px-3 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30" />
                    }
                </div>
                }

            </div>

            <!-- ================= OBSERVACIONES ================= -->
            @if (!isViewMode || selectedSale?.observations) {
            <div
                class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/[0.03]">
                <h4 class="text-base font-semibold mb-3 text-gray-800 dark:text-white/90">Observaciones</h4>
                @if (isViewMode) {
                <p class="text-sm text-gray-600 dark:text-gray-300 whitespace-pre-line">{{ selectedSale?.observations }}</p>
                } @else {
                <textarea rows="3" [(ngModel)]="observations" placeholder="Observaciones opcionales..."
                    class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500/20 dark:bg-gray-900 dark:border-gray-700 dark:text-white dark:placeholder:text-white/30 resize-none"></textarea>
                }
            </div>
            }

            <!-- ================= DETALLE ================= -->
            <div
                class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/[0.03]">

                <div class="flex items-start justify-between mb-1">
                    <h4 class="text-base font-semibold text-gray-800 dark:text-white/90">
                        Detalle de venta
                    </h4>

                    @if (!isViewMode) {
                    <div class="flex gap-2 flex-wrap justify-end">
                        <button type="button"
                            class="inline-flex items-center gap-1.5 rounded-lg bg-brand-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-brand-600 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                            [disabled]="!canAddProduct"
                            [title]="!canAddProduct ? 'No puedes agregar productos junto a servicios con detracción' : ''"
                            (click)="openProductModal()">
                            <span class="text-lg leading-none">+</span> Agregar producto
                        </button>

                        <button type="button"
                            class="inline-flex items-center gap-1.5 rounded-lg bg-indigo-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-indigo-600 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                            [disabled]="!canAddService"
                            [title]="!canAddService ? 'No puedes agregar servicios junto a productos con detracción' : ''"
                            (click)="openServiceModal()">
                            <span class="text-lg leading-none">+</span> Agregar servicio
                        </button>

                        <button type="button"
                            class="inline-flex items-center gap-1.5 rounded-lg border border-yellow-400 bg-yellow-50 px-3 py-1.5 text-sm font-medium text-yellow-700 hover:bg-yellow-100 dark:bg-yellow-900/20 dark:border-yellow-600 dark:text-yellow-400 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                            [disabled]="!canAddService"
                            [title]="!canAddService ? 'No puedes agregar servicios junto a productos con detracción' : ''"
                            (click)="openQuickServiceModal()">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M13 3L4 14h8l-1 7 9-11h-8l1-7z" />
                            </svg>
                            Servicio rápido
                        </button>
                    </div>
                    }

                </div>

                @if (!isViewMode) {
                <p class="text-xs text-gray-400 mb-4 dark:text-gray-500">
                    Agrega varios productos o servicios. Para servicios no registrados, usa "Servicio rápido".
                </p>
                }

                <!-- TABLA DE ITEMS -->
                <div class="overflow-x-auto rounded-lg">
                    <table class="min-w-full text-sm">

                        <thead class="border-b border-gray-200 dark:border-white/[0.05] bg-gray-50 dark:bg-gray-800/50">
                            <tr class="text-gray-500 dark:text-gray-400">
                                <th class="py-3 px-3 text-left font-medium text-xs uppercase tracking-wider">Tipo</th>
                                <th class="py-3 px-3 text-left font-medium text-xs uppercase tracking-wider">Ítem</th>
                                <th class="py-3 px-3 text-center font-medium text-xs uppercase tracking-wider">Precio
                                </th>
                                <th class="py-3 px-3 text-center font-medium text-xs uppercase tracking-wider">Cant.
                                </th>
                                <th class="py-3 px-3 text-center font-medium text-xs uppercase tracking-wider">Dscto %
                                </th>
                                <th class="py-3 px-3 text-center font-medium text-xs uppercase tracking-wider">Subtotal
                                </th>
                                @if (!isViewMode) {
                                <th class="py-3 px-3 text-center font-medium text-xs uppercase tracking-wider">Acción
                                </th>
                                }

                            </tr>
                        </thead>

                        <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">

                            @if (items.length === 0) {
                            <tr>
                                <td colspan="7" class="py-8 text-center text-gray-400">
                                    Aún no hay items agregados.
                                </td>
                            </tr>
                            }

                            @for (item of items; track $index; let i = $index) {
                            <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/40 transition-colors">

                                <td class="py-3 px-3">
                                    <span class="inline-flex items-center text-xs font-medium px-2.5 py-1 rounded-full"
                                        [class.bg-brand-100]="item.itemType === 'PRODUCTO'"
                                        [class.text-brand-700]="item.itemType === 'PRODUCTO'"
                                        [class.dark:bg-brand-900/30]="item.itemType === 'PRODUCTO'"
                                        [class.dark:text-brand-300]="item.itemType === 'PRODUCTO'"
                                        [class.bg-indigo-100]="item.itemType === 'SERVICIO'"
                                        [class.text-indigo-700]="item.itemType === 'SERVICIO'"
                                        [class.dark:bg-indigo-900/30]="item.itemType === 'SERVICIO'"
                                        [class.dark:text-indigo-300]="item.itemType === 'SERVICIO'"
                                        [class.bg-gray-100]="item.itemType === 'PERSONALIZADO'"
                                        [class.text-gray-700]="item.itemType === 'PERSONALIZADO'"
                                        [class.dark:bg-gray-800]="item.itemType === 'PERSONALIZADO'"
                                        [class.dark:text-gray-300]="item.itemType === 'PERSONALIZADO'">
                                        {{ item.itemType }}
                                    </span>
                                </td>

                                <td class="py-3 px-3 font-medium text-gray-800 dark:text-white">
                                    <span class="flex items-center gap-2">
                                        {{ item.description }}
                                        @if (item._detractionCode) {
                                        <span class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-400">
                                            Det. {{ item._detractionCode }}
                                        </span>
                                        }
                                    </span>
                                </td>

                                <td class="py-3 px-3 text-center text-gray-600 dark:text-gray-400">
                                    {{ currencySymbol }} {{ item.unitPrice | number:'1.2-2' }}
                                </td>

                                <td class="py-3 px-3 text-center">
                                    @if (!isViewMode) {
                                    <input type="number" min="1" step="1" [(ngModel)]="item.quantity"
                                        class="w-16 rounded-md border border-gray-300 bg-white px-2 py-1 text-center text-sm text-gray-800 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500/20 dark:bg-gray-900 dark:border-gray-700 dark:text-white">
                                    } @else {
                                    <span class="text-gray-600 dark:text-gray-400">{{ item.quantity }}</span>
                                    }
                                </td>

                                <td class="py-3 px-3 text-center">
                                    @if (!isViewMode) {
                                    <input type="number" min="0" max="100" step="1"
                                        [(ngModel)]="item.discountPercentage"
                                        class="w-16 rounded-md border border-gray-300 bg-white px-2 py-1 text-center text-sm text-gray-800 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500/20 dark:bg-gray-900 dark:border-gray-700 dark:text-white">
                                    } @else {
                                    <span
                                        class="text-gray-600 dark:text-gray-400">{{ item.discountPercentage || 0 }}%</span>
                                    }
                                </td>

                                <td class="py-3 px-3 text-center font-semibold text-gray-800 dark:text-white">
                                    {{ currencySymbol }}
                                    {{ item.quantity * item.unitPrice * (1 - (item.discountPercentage || 0) / 100) | number:'1.2-2' }}
                                </td>

                                @if (!isViewMode) {
                                <td class="py-3 text-center">
                                    <button type="button"
                                        class="inline-flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium text-white bg-red-500 hover:bg-red-600 rounded-md transition-colors"
                                        (click)="removeItem(i)">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M14.7223 12.7585C14.7426 12.3448 14.4237 11.9929 14.01 11.9726C13.5963 11.9522 13.2444 12.2711 13.2241 12.6848L12.9999 17.2415C12.9796 17.6552 13.2985 18.0071 13.7122 18.0274C14.1259 18.0478 14.4778 17.7289 14.4981 17.3152L14.7223 12.7585Z"
                                                fill="white" />
                                            <path
                                                d="M9.98802 11.9726C9.5743 11.9929 9.25542 12.3448 9.27577 12.7585L9.49993 17.3152C9.52028 17.7289 9.87216 18.0478 10.2859 18.0274C10.6996 18.0071 11.0185 17.6552 10.9981 17.2415L10.774 12.6848C10.7536 12.2711 10.4017 11.9522 9.98802 11.9726Z"
                                                fill="white" />
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M10.249 2C9.00638 2 7.99902 3.00736 7.99902 4.25V5H5.5C4.25736 5 3.25 6.00736 3.25 7.25C3.25 8.28958 3.95503 9.16449 4.91303 9.42267L5.54076 19.8848C5.61205 21.0729 6.59642 22 7.78672 22H16.2113C17.4016 22 18.386 21.0729 18.4573 19.8848L19.085 9.42267C20.043 9.16449 20.748 8.28958 20.748 7.25C20.748 6.00736 19.7407 5 18.498 5H15.999V4.25C15.999 3.00736 14.9917 2 13.749 2H10.249ZM14.499 5V4.25C14.499 3.83579 14.1632 3.5 13.749 3.5H10.249C9.83481 3.5 9.49902 3.83579 9.49902 4.25V5H14.499ZM5.5 6.5C5.08579 6.5 4.75 6.83579 4.75 7.25C4.75 7.66421 5.08579 8 5.5 8H18.498C18.9123 8 19.248 7.66421 19.248 7.25C19.248 6.83579 18.9123 6.5 18.498 6.5H5.5ZM6.42037 9.5H17.5777L16.96 19.7949C16.9362 20.191 16.6081 20.5 16.2113 20.5H7.78672C7.38995 20.5 7.06183 20.191 7.03807 19.7949L6.42037 9.5Z"
                                                fill="white" />
                                        </svg>
                                        Eliminar
                                    </button>
                                </td>
                                }


                            </tr>
                            }

                        </tbody>
                    </table>
                </div>

                <!-- ORDEN DE COMPRA + DOCUMENTOS RELACIONADOS (debajo de la tabla) -->
                @if (!isViewMode || selectedSale?.purchaseOrder || selectedSale?.otNumber || selectedSale?.relatedGuides?.length) {
                <div class="grid grid-cols-1 gap-4 sm:grid-cols-3 mt-5 pt-5 border-t border-gray-100 dark:border-gray-700">

                    <!-- Orden de compra -->
                    <div>
                        <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2 uppercase tracking-wide">Orden de compra</p>
                        @if (isViewMode) {
                        <p class="text-sm text-gray-700 dark:text-gray-300">{{ selectedSale?.purchaseOrder || '—' }}</p>
                        } @else {
                        <app-input-field type="text" [(value)]="purchaseOrder" placeholder="Ej: OC-2026-001" />
                        }
                    </div>

                    <!-- OT IDMH -->
                    <div>
                        <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2 uppercase tracking-wide">
                            OT IDMH @if (isFactura) {*}
                        </p>
                        @if (isViewMode) {
                        <p class="text-sm text-gray-700 dark:text-gray-300">{{ selectedSale?.otNumber || '—' }}</p>
                        } @else {
                        <app-ot-input [(value)]="otNumber"></app-ot-input>
                        }
                    </div>

                    <!-- Documentos relacionados -->
                    <div>
                        <p class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2 uppercase tracking-wide">Documentos relacionados</p>
                        @if (isViewMode) {
                        <div class="space-y-1">
                            @if (selectedSale?.relatedGuides?.length) {
                            @for (g of selectedSale!.relatedGuides; track $index) {
                            <p class="text-sm text-gray-700 dark:text-gray-300">{{ g }}</p>
                            }
                            } @else {
                            <p class="text-sm text-gray-400">—</p>
                            }
                        </div>
                        } @else {
                        @for (g of relatedGuides; track $index; let i = $index) {
                        <div class="flex items-center gap-2 mb-2">
                            <app-input-field type="text" class="w-100" [value]="relatedGuides[i]"
                                (valueChange)="relatedGuides[i] = $event.toString()"
                                placeholder="Ej: T001-00000001" />
                            <button type="button" class="flex-shrink-0 text-red-500 hover:text-red-600"
                                (click)="removeRelatedGuide(i)">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        }
                        <button type="button"
                            class="inline-flex items-center justify-center gap-1 rounded-lg bg-gray-200 px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 transition-colors"
                            (click)="addRelatedGuide()">
                            <span class="text-sm">+</span> Agregar documento
                        </button>
                        }
                    </div>

                </div>
                }

            </div>

        </div>

        <!-- ========================================================= -->
        <!-- DERECHA (SIDEBAR) -->
        <!-- ========================================================= -->
        <div class="space-y-6">

            <!-- ================= TOTALES ================= -->
            <div
                class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/[0.03]">

                <h4 class="text-base font-semibold mb-4 text-gray-800 dark:text-white">
                    Totales
                </h4>

                <div class="space-y-3 text-sm">

                    <div class="flex justify-between dark:text-white/90">
                        <span>Subtotal</span>
                        <span>{{ isViewMode ? (selectedSale?.currencyCode === 'USD' ? '$' : 'S/') : currencySymbol }}
                            {{ (isViewMode ? (selectedSale?.subtotalAmount ?? 0) : subtotal) | number:'1.2-2' }}</span>
                    </div>

                    <div class="flex justify-between dark:text-white/90">
                        <span>IGV (18%)</span>
                        <span>{{ isViewMode ? (selectedSale?.currencyCode === 'USD' ? '$' : 'S/') : currencySymbol }} {{ (isViewMode ? (selectedSale?.taxAmount ?? 0) : igv) | number:'1.2-2' }}</span>
                    </div>

                    <div class="flex justify-between border-t pt-3 text-base font-semibold dark:text-white/90">
                        <span>Total</span>
                        <span>{{ isViewMode ? (selectedSale?.currencyCode === 'USD' ? '$' : 'S/') : currencySymbol }} {{ (isViewMode ? (selectedSale?.totalAmount ?? 0) : total) | number:'1.2-2' }}</span>
                    </div>

                </div>

            </div>

            <!-- ================= RETENCIÓN IGV ================= -->
            @if (!isViewMode && clientIsRetentionAgent && !activeDetraction) {
            <div
                class="rounded-2xl border border-blue-200 bg-blue-50 p-6 shadow-sm dark:border-blue-900 dark:bg-blue-950/30">
                <h4 class="text-base font-semibold mb-4 text-gray-800 dark:text-white">Retención IGV</h4>
                <p class="text-xs text-blue-600 dark:text-blue-400 mb-4 leading-relaxed">
                    La retención se evalúa al cobro. Se activa automáticamente cuando el cliente es agente de
                    retención, el comprobante es factura y el total supera S/ 700 o su equivalente en dólares.
                </p>

                <div class="space-y-3 text-sm">
                    <div class="grid grid-cols-2 gap-3">
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-blue-100 dark:border-blue-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Cliente agente de retención</p>
                            <p class="font-semibold text-gray-800 dark:text-white">Sí</p>
                        </div>
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-blue-100 dark:border-blue-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">¿Aplica retención?</p>
                            <p class="font-semibold" [class.text-green-600]="retentionApplies" [class.text-gray-500]="!retentionApplies">
                                {{ retentionApplies ? 'Sí' : 'No' }}
                            </p>
                        </div>
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-blue-100 dark:border-blue-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Porcentaje</p>
                            <p class="font-semibold text-gray-800 dark:text-white">
                                {{ retentionApplies ? (RETENTION_RATE * 100 | number:'1.2-2') : '0.00' }} %
                            </p>
                        </div>
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-blue-100 dark:border-blue-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Monto de retención</p>
                            <p class="font-semibold text-gray-800 dark:text-white">S/ {{ retentionAmountPen | number:'1.2-2' }}</p>
                        </div>
                    </div>
                    <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-blue-100 dark:border-blue-800">
                        <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Monto neto a recibir</p>
                        <p class="text-base font-bold text-gray-800 dark:text-white">{{ currencySymbol }} {{ netAmount | number:'1.2-2' }}</p>
                        @if (currencyCode === 'USD' && retentionApplies) {
                        <p class="text-sm text-gray-400 dark:text-gray-500 mt-0.5">≈ S/ {{ netAmountPen | number:'1.2-2' }}</p>
                        }
                    </div>
                </div>

                <p class="mt-4 text-xs text-blue-500 dark:text-blue-400">La retención solo aplica a facturas.</p>
            </div>
            }

            @if (isViewMode && selectedSale?.hasRetention) {
            <div
                class="rounded-2xl border border-blue-200 bg-blue-50 p-6 shadow-sm dark:border-blue-900 dark:bg-blue-950/30">
                <h4 class="text-base font-semibold mb-4 text-gray-800 dark:text-white">Retención IGV</h4>
                <div class="space-y-3 text-sm">
                    <div class="grid grid-cols-2 gap-3">
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-blue-100 dark:border-blue-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">¿Aplica retención?</p>
                            <p class="font-semibold text-green-600">Sí</p>
                        </div>
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-blue-100 dark:border-blue-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Porcentaje</p>
                            <p class="font-semibold text-gray-800 dark:text-white">{{ ((selectedSale?.retentionRate ?? 0) * 100) | number:'1.2-2' }} %</p>
                        </div>
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-blue-100 dark:border-blue-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Monto de retención</p>
                            <p class="font-semibold text-gray-800 dark:text-white">S/ {{ selectedSale?.retentionAmount ?? 0 | number:'1.2-2' }}</p>
                        </div>
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-blue-100 dark:border-blue-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Monto neto a recibir</p>
                            <p class="font-semibold text-gray-800 dark:text-white">{{ currencySymbol }} {{ selectedSale?.netAmount ?? 0 | number:'1.2-2' }}</p>
                        </div>
                    </div>
                </div>
            </div>
            }

            <!-- ================= DETRACCIÓN SPOT (edición) ================= -->
            @if (!isViewMode && activeDetraction) {
            <div class="rounded-2xl border border-teal-200 bg-teal-50 p-6 shadow-sm dark:border-teal-900 dark:bg-teal-950/30">
                <h4 class="text-base font-semibold mb-1 text-gray-800 dark:text-white">Detracción (SPOT)</h4>
                <p class="text-xs text-teal-600 dark:text-teal-400 mb-4 leading-relaxed">
                    Se calcula automáticamente según los ítems, el tipo de comprobante y el monto de la operación. Aplica cuando el total supera S/ {{ detractionMinAmount | number:'1.2-2' }} o su equivalente en dólares.
                </p>

                <div class="space-y-3 text-sm">
                    <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-teal-100 dark:border-teal-800">
                        <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Condición de la operación</p>
                        <p class="font-semibold"
                            [class.text-green-600]="detractionCondition === 'Sujeto a detracción'"
                            [class.text-gray-500]="detractionCondition !== 'Sujeto a detracción'">
                            {{ detractionCondition }}
                        </p>
                    </div>

                    @if (activeDetraction) {
                    <div class="grid grid-cols-2 gap-3">
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-teal-100 dark:border-teal-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Código detracción</p>
                            <p class="font-semibold text-gray-800 dark:text-white">{{ activeDetraction.code }}</p>
                        </div>
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-teal-100 dark:border-teal-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Porcentaje</p>
                            <p class="font-semibold text-gray-800 dark:text-white">{{ activeDetraction.percentage | number:'1.2-2' }} %</p>
                        </div>
                    </div>
                    <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-teal-100 dark:border-teal-800">
                        <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Concepto SUNAT</p>
                        <p class="font-semibold text-gray-800 dark:text-white">{{ activeDetraction.description }}</p>
                    </div>
                    <div class="grid grid-cols-2 gap-3">
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-teal-100 dark:border-teal-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Monto detracción</p>
                            <p class="font-semibold text-gray-800 dark:text-white">S/ {{ detractionAmountPen | number:'1.2-2' }}</p>
                        </div>
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-teal-100 dark:border-teal-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Monto neto a cobrar</p>
                            <p class="font-semibold text-gray-800 dark:text-white">{{ currencySymbol }} {{ detractionNetAmount | number:'1.2-2' }}</p>
                        </div>
                    </div>
                    } @else {
                    <p class="text-xs text-teal-500 dark:text-teal-400">
                        {{ items.length === 0 ? 'Agrega ítems para evaluar la detracción.' : 'Los ítems agregados no están sujetos a detracción.' }}
                    </p>
                    }
                </div>
            </div>
            }

            @if (isViewMode && selectedSale?.hasDetraction) {
            <div class="rounded-2xl border border-teal-200 bg-teal-50 p-6 shadow-sm dark:border-teal-900 dark:bg-teal-950/30">
                <h4 class="text-base font-semibold mb-4 text-gray-800 dark:text-white">Detracción (SPOT)</h4>
                <div class="space-y-3 text-sm">
                    <div class="grid grid-cols-2 gap-3">
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-teal-100 dark:border-teal-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Código detracción</p>
                            <p class="font-semibold text-gray-800 dark:text-white">{{ selectedSale?.detractionCode ?? '—' }}</p>
                        </div>
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-teal-100 dark:border-teal-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Porcentaje</p>
                            <p class="font-semibold text-gray-800 dark:text-white">{{ (selectedSale?.detractionRate ?? 0) | number:'1.2-2' }} %</p>
                        </div>
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-teal-100 dark:border-teal-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Monto detracción</p>
                            <p class="font-semibold text-gray-800 dark:text-white">S/ {{ (selectedSale?.detractionAmount ?? 0) | number:'1.2-2' }}</p>
                        </div>
                        <div class="rounded-lg bg-white dark:bg-white/[0.05] p-3 border border-teal-100 dark:border-teal-800">
                            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Monto neto a cobrar</p>
                            <p class="font-semibold text-gray-800 dark:text-white">
                                {{ selectedSale?.currencyCode === 'USD' ? '$' : 'S/' }}
                                {{ ((selectedSale?.totalAmount ?? 0) * (1 - (selectedSale?.detractionRate ?? 0) / 100)) | number:'1.2-2' }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            }

            <!-- ================= FORMA DE PAGO (solo en modo edición) ================= -->
            @if (!isViewMode) {
            <div
                class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/[0.03]">

                <!-- Toggle CONTADO / CRÉDITO -->
                <div class="flex items-center justify-between mb-4">
                    <h4 class="text-base font-semibold text-gray-800 dark:text-white">Forma de pago</h4>
                    <div class="flex rounded-lg border border-gray-300 dark:border-gray-700 overflow-hidden text-sm font-medium">
                        <button type="button"
                            class="px-3 py-1.5 transition-colors"
                            [class.bg-brand-500]="paymentType === 'CONTADO'"
                            [class.text-white]="paymentType === 'CONTADO'"
                            [class.text-gray-600]="paymentType !== 'CONTADO'"
                            [class.dark:text-gray-300]="paymentType !== 'CONTADO'"
                            (click)="paymentType = 'CONTADO'; installments = []">
                            Contado
                        </button>
                        <button type="button"
                            class="px-3 py-1.5 transition-colors border-l border-gray-300 dark:border-gray-700"
                            [class.bg-brand-500]="paymentType === 'CREDITO'"
                            [class.text-white]="paymentType === 'CREDITO'"
                            [class.text-gray-600]="paymentType !== 'CREDITO'"
                            [class.dark:text-gray-300]="paymentType !== 'CREDITO'"
                            (click)="paymentType = 'CREDITO'; payments = []">
                            Crédito
                        </button>
                    </div>
                </div>

                <!-- PAGOS (contado) -->
                @if (paymentType === 'CONTADO') {

                @for (p of payments; track $index; let i = $index) {
                <div class="mb-4 border-b pb-4 dark:border-gray-700">

                    <div class="mb-3">
                        <app-label>Método de pago</app-label>
                        <app-select placeholder="Seleccione método de pago" [options]="paymentMethodOptions"
                            [(value)]="p.paymentMethodId">
                        </app-select>
                    </div>

                    <div class="mb-3">
                        <app-label>Monto pagado</app-label>
                        <app-input-field type="number" [step]="0.01" min="0" placeholder="0.00" [(value)]="p.amountPaid">
                        </app-input-field>
                    </div>

                    <div class="mb-3">
                        <app-label>Referencia (opcional)</app-label>
                        <app-input-field type="text" placeholder="Número de operación" [(value)]="p.paymentReference">
                        </app-input-field>
                    </div>

                    <div class="mb-3">
                        <app-label>Comprobante de pago</app-label>
                        <app-file-input accept="image/*,application/pdf" (change)="onPaymentFileChange(i, $event)">
                        </app-file-input>
                    </div>

                    <button type="button" class="text-red-500 hover:text-red-600 text-sm font-medium"
                        (click)="removePayment(i)">
                        🗑️ Eliminar pago
                    </button>

                </div>
                }

                <button type="button"
                    class="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-gray-200 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 transition-colors"
                    (click)="addPayment()">
                    <span class="text-lg">+</span> Agregar pago
                </button>

                <div class="mt-4 text-sm space-y-2">
                    <div class="flex justify-between dark:text-white/90">
                        <span>Total pagado</span>
                        <span>{{ currencySymbol }} {{ totalPaid | number:'1.2-2' }}</span>
                    </div>

                    <div class="flex justify-between font-medium dark:text-white/90">
                        <span>{{ (retentionApplies || detractionEffective) ? 'Diferencia con monto neto' : 'Vuelto' }}</span>
                        <span [class.text-red-500]="change < 0">
                            {{ currencySymbol }} {{ change | number:'1.2-2' }}
                        </span>
                    </div>
                </div>

                }

                <!-- CUOTAS (crédito) -->
                @if (paymentType === 'CREDITO') {

                @for (inst of installments; track $index; let i = $index) {
                <div class="mb-4 border-b pb-4 dark:border-gray-700">
                    <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 mb-2">Cuota {{ inst.installmentNumber }}</p>

                    <div class="mb-2">
                        <app-label>Fecha vencimiento</app-label>
                        <app-date-picker
                            placeholder="Seleccionar fecha"
                            [minDate]="tomorrowStr"
                            [defaultDate]="inst.dueDate || undefined"
                            (dateChange)="inst.dueDate = $event.dateStr">
                        </app-date-picker>
                    </div>

                    <div class="mb-2">
                        <app-label>Monto ({{ currencySymbol }})</app-label>
                        <app-input-field type="number" [step]="0.01" min="0" placeholder="0.00" [(value)]="inst.amount">
                        </app-input-field>
                    </div>

                    <button type="button" class="text-red-500 hover:text-red-600 text-sm font-medium"
                        (click)="removeInstallment(i)">
                        🗑️ Eliminar cuota
                    </button>
                </div>
                }

                <button type="button"
                    class="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-gray-200 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 transition-colors"
                    (click)="addInstallment()">
                    <span class="text-lg">+</span> Agregar cuota
                </button>

                <div class="mt-4 text-sm space-y-2">
                    <div class="flex justify-between dark:text-white/90">
                        <span>Total cuotas</span>
                        <span [class.text-red-500]="!installmentsBalanced">
                            {{ currencySymbol }} {{ installmentsTotal | number:'1.2-2' }}
                        </span>
                    </div>
                    @if (!installmentsBalanced) {
                    <p class="text-xs text-red-500">Diferencia con el {{ (retentionApplies || detractionEffective) ? 'monto neto' : 'total' }}: {{ currencySymbol }} {{ installmentsDiff | number:'1.2-2' }}</p>
                    }
                </div>

                }

            </div>
            }

            <!-- ================= CUOTAS (modo vista - crédito) ================= -->
            @if (isViewMode && selectedSale?.paymentType === 'CREDITO' && selectedSale?.installments?.length) {
            <div
                class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/[0.03]">

                <h4 class="text-base font-semibold mb-4 text-gray-800 dark:text-white">Cuotas registradas</h4>

                <div class="space-y-2">
                    @for (inst of selectedSale!.installments; track inst.id) {
                    <div class="rounded-lg border border-gray-100 dark:border-gray-700 p-3 text-sm flex items-center justify-between">
                        <div>
                            <p class="font-medium text-gray-800 dark:text-white">Cuota {{ inst.installmentNumber }}</p>
                            <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Vence: {{ inst.dueDate }}</p>
                        </div>
                        <span class="font-semibold text-gray-800 dark:text-white">
                            {{ selectedSale!.currencyCode === 'USD' ? '$' : 'S/' }} {{ inst.amount | number:'1.2-2' }}
                        </span>
                    </div>
                    }
                </div>

                <div
                    class="mt-3 pt-3 border-t border-gray-100 dark:border-gray-700 flex justify-between text-sm font-semibold text-gray-800 dark:text-white">
                    <span>Total cuotas</span>
                    <span>{{ selectedSale!.currencyCode === 'USD' ? '$' : 'S/' }} {{ getViewInstallmentTotal() | number:'1.2-2' }}</span>
                </div>

            </div>
            }

            <!-- ================= PAGOS (modo vista) ================= -->
            @if (isViewMode && selectedSale?.paymentType !== 'CREDITO' && selectedSale?.payments?.length) {
            <div
                class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/[0.03]">

                <h4 class="text-base font-semibold mb-4 text-gray-800 dark:text-white">Pagos registrados</h4>

                <div class="space-y-3">
                    @for (p of selectedSale!.payments; track p.id) {
                    <div class="rounded-lg border border-gray-100 dark:border-gray-700 p-3 text-sm space-y-1.5">

                        <div class="flex items-center justify-between">
                            <span class="font-medium text-gray-800 dark:text-white">
                                {{ p.paymentMethodName ?? 'Pago - ' + p.paymentMethod?.name }}
                            </span>
                        </div>

                        @if (p.paymentReference) {
                        <p class="text-xs text-gray-500 dark:text-gray-400">
                            Ref: {{ p.paymentReference }} / {{ currencySymbol }} {{ p.amountPaid }}
                        </p>
                        } @else {
                        <p class="text-xs text-gray-500 dark:text-gray-400">
                            {{ currencySymbol }} {{ p.amountPaid }}
                        </p>
                        }

                        @if (p.proofFileUrl) {
                        <a [href]="p.proofFileUrl" target="_blank"
                            class="inline-flex items-center gap-1 text-brand-500 font-medium text-xs hover:underline">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                            Ver comprobante de pago
                        </a>
                        } @else {
                        <span class="text-xs text-gray-400 dark:text-gray-600">Sin comprobante adjunto</span>
                        }

                    </div>
                    }
                </div>

                <!-- Total pagado -->
                <div
                    class="mt-3 pt-3 border-t border-gray-100 dark:border-gray-700 flex justify-between text-sm font-semibold text-gray-800 dark:text-white">
                    <span>Total pagado</span>
                    <span>{{ currencySymbol }} {{ getViewPaymentTotal() | number:'1.2-2' }}</span>
                </div>

            </div>
            }

            <!-- ================= COMPROBANTE / DOCUMENTO ================= -->
            <div
                class="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm dark:border-gray-800 dark:bg-white/[0.03]">

                @if (isViewMode) {

                <!-- Modo vista: info del documento emitido -->
                <h4 class="text-base font-semibold mb-4 text-gray-800 dark:text-white">
                    Documento emitido
                </h4>

                @if (selectedSale?.document) {
                <div class="space-y-3 text-sm">

                    <div class="flex justify-between">
                        <span class="text-gray-500 dark:text-gray-400">Serie / Número</span>
                        <span class="font-semibold text-gray-800 dark:text-white">
                            {{ selectedSale!.document?.series }}-{{ selectedSale!.document?.sequence }}
                        </span>
                    </div>

                    <div class="flex justify-between">
                        <span class="text-gray-500 dark:text-gray-400">Fecha emisión</span>
                        <span class="text-gray-700 dark:text-gray-300">
                            {{ selectedSale!.document?.issueDate | date:'dd/MM/yyyy' }}
                        </span>
                    </div>

                    <div class="flex justify-between items-center">
                        <span class="text-gray-500 dark:text-gray-400">Estado SUNAT</span>
                        <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                            [class.bg-green-100]="selectedSale!.document?.status === 'ACEPTADO'"
                            [class.text-green-700]="selectedSale!.document?.status === 'ACEPTADO'"
                            [class.bg-red-100]="selectedSale!.document?.status !== 'ACEPTADO'"
                            [class.text-red-700]="selectedSale!.document?.status !== 'ACEPTADO'">
                            {{ selectedSale!.document?.status }}
                        </span>
                    </div>

                    @if (selectedSale!.document?.sunatMessage) {
                    <div
                        class="rounded-lg bg-gray-50 dark:bg-gray-800/50 p-3 text-xs text-gray-600 dark:text-gray-400 leading-relaxed">
                        <span class="font-medium text-gray-700 dark:text-gray-300">
                            Código {{ selectedSale!.document?.sunatResponseCode }}:
                        </span>
                        {{ selectedSale!.document?.sunatMessage }}
                    </div>
                    }

                    @if (selectedSale!.document?.pdfUrl) {
                    <a [href]="selectedSale!.document?.pdfUrl" target="_blank"
                        class="mt-2 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-red-500 hover:bg-red-600 px-3 py-2 text-sm font-medium text-white transition-colors">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 13h6M9 17h6M9 9h3" />
                        </svg>
                        Ver PDF
                    </a>
                    }

                </div>
                } @else {
                <p class="text-sm text-gray-400">Sin comprobante emitido.</p>
                }

                } @else {

                <!-- Modo edición: ingresar serie -->
                <h4 class="text-base font-semibold mb-4 text-gray-800 dark:text-white">
                    Comprobante
                </h4>

                <div class="space-y-4">

                    <!-- TIPO DOCUMENTO -->
                    <div>
                        <app-label>Tipo de documento *</app-label>

                        <app-select placeholder="Selecciona el tipo de documento" [options]="[
                                { value: '03', label: 'Boleta' },
                                { value: '01', label: 'Factura' }
                            ]" [(value)]="documentTypeCode" [disabled]="documentTypeLocked"
                            (valueChange)="onDocumentTypeChange()">
                        </app-select>
                    </div>

                    <div>
                        <app-label>Documento</app-label>

                        <app-input-field type="text" [value]="formattedDocument" [disabled]="true"
                            placeholder="Cargando...">
                        </app-input-field>
                    </div>

                    <!-- Loader -->
                    @if (loadingSeries) {
                    <p class="text-xs text-gray-400 animate-pulse">
                        Obteniendo correlativo...
                    </p>
                    }

                </div>

                }

            </div>

        </div>

    </div>

    <!-- FOOTER -->
    <div class="flex items-center justify-end gap-3 mt-8 border-t border-gray-200 dark:border-gray-700 pt-6">

        @if (isViewMode) {

        <button type="button" (click)="closeModal()"
            class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cerrar
        </button>

        } @else {

        <button type="button" (click)="closeModal()"
            class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cancelar
        </button>

        <button type="button" (click)="onGenerateQuotation()"
            [disabled]="isGeneratingQuotation || isSubmitting"
            class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white rounded-lg bg-teal-500 hover:bg-teal-600 disabled:opacity-50 disabled:cursor-not-allowed">
            @if (isGeneratingQuotation) {
            <svg class="animate-spin w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="white" stroke-width="3" stroke-dasharray="31.4 31.4" stroke-linecap="round"/>
            </svg>
            Generando…
            } @else {
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 2V8H20M16 13H8M16 17H8M10 9H8" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Cotización
            }
        </button>

        <button type="button" (click)="submitSale(false)" [disabled]="isSubmitting"
            class="px-4 py-2 text-sm font-medium text-gray-700 rounded-lg border border-gray-300 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800 disabled:opacity-50">
            Guardar borrador
        </button>

        <button type="button" (click)="submitSale(true)" [disabled]="isSubmitting"
            class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-brand-500 hover:bg-brand-600 disabled:opacity-50">
            {{ isSubmitting ? 'Procesando…' : 'Finalizar y emitir' }}
        </button>

        }

    </div>

</app-modal>

<!-- ================================================================ -->
<!-- MODAL BUSCAR CLIENTE -->
<!-- ================================================================ -->
<app-modal [isOpen]="showClientModal" [className]="'max-w-2xl p-6'" (close)="showClientModal = false">

    <div class="mb-5">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">
            Buscar cliente
        </h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">
            Buscar por nombre / razón social / documento
        </p>
    </div>

    <!-- BUSCADOR -->
    <div class="mb-5">
        <div class="relative">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>
            <input type="text" [(ngModel)]="clientSearchTerm" (input)="searchClients()"
                placeholder="Ej: Pérez / 12345678 / 20123456789"
                class="w-full pl-10 pr-4 py-2.5 rounded-lg border border-gray-300 bg-white text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20 dark:bg-gray-900 dark:border-gray-700 dark:text-white dark:placeholder:text-gray-500"
                autofocus>
        </div>
    </div>

    <!-- RESULTADOS -->
    <div class="max-h-[400px] overflow-y-auto border border-gray-200 rounded-lg dark:border-gray-700">

        @if (loadingClients) {
        <div class="py-12 text-center text-gray-500 dark:text-gray-400">
            <svg class="w-16 h-16 mx-auto mb-3 text-gray-400 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                </path>
            </svg>
            <p class="text-sm">Cargando clientes...</p>
        </div>
        }
        @else if (clientResults.length === 0 && !clientSearchTerm) {
        <div class="py-12 text-center text-gray-500 dark:text-gray-400">
            <svg class="w-16 h-16 mx-auto mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <p class="text-sm">Mostrando todos los clientes activos</p>
            <p class="text-xs mt-1">Usa el buscador para filtrar</p>
        </div>
        }
        @else if (clientResults.length === 0) {
        <div class="py-12 text-center text-gray-500 dark:text-gray-400">
            <svg class="w-16 h-16 mx-auto mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M12 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p class="text-sm">No se encontraron clientes</p>
        </div>
        }
        @else {
        <div class="divide-y divide-gray-200 dark:divide-gray-700">
            @for (client of pagedClientResults; track client.id) {
            <div class="p-4 hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer transition-colors"
                (click)="selectClient(client)">

                <div class="flex items-start justify-between">
                    <div class="flex-1">
                        <div class="flex items-center gap-2 mb-1">
                            <h4 class="font-semibold text-gray-800 dark:text-white">
                                {{ getClientFullName(client) }}
                            </h4>
                        </div>

                        <p class="text-sm text-gray-600 dark:text-gray-400 flex items-center gap-2">
                            {{ client.documentType }}: {{ client.documentNumber }}
                            @if (client.retentionAgent) {
                            <span class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400">
                                Ag. Retención
                            </span>
                            }
                        </p>

                        <p class="text-xs text-gray-500 dark:text-gray-500 mt-1">
                            @if (client.addresses?.length) { 📍 {{ client.addresses![0].address }} }
                            @if (client.phone1) { - 📞 {{ client.phone1 }} }
                        </p>
                    </div>

                    <button type="button"
                        class="ml-4 px-3 py-1.5 my-auto text-sm font-medium text-white bg-brand-500 hover:bg-brand-600 rounded-lg transition-colors"
                        (click)="selectClient(client); $event.stopPropagation()">
                        Seleccionar
                    </button>
                </div>
            </div>
            }
        </div>
        }
    </div>

    <!-- PAGINACIÓN -->
    @if (clientResults.length > clientPageSize) {
    <div class="flex items-center justify-between mt-4 px-1">
        <p class="text-xs text-gray-500 dark:text-gray-400">
            Mostrando {{ (clientCurrentPage - 1) * clientPageSize + 1 }}–{{ clientPageEnd }} de
            {{ clientResults.length }} clientes
        </p>
        <div class="flex items-center gap-1">
            <button type="button" [disabled]="clientCurrentPage === 1" (click)="clientPrevPage()"
                class="inline-flex items-center px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
            </button>

            <span class="px-3 py-1.5 text-sm text-gray-700 dark:text-gray-300">
                {{ clientCurrentPage }} / {{ clientTotalPages }}
            </span>

            <button type="button" [disabled]="clientCurrentPage === clientTotalPages" (click)="clientNextPage()"
                class="inline-flex items-center px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
    </div>
    }

    <!-- FOOTER -->
    <div class="flex justify-between gap-3 mt-5 pt-5 border-t border-gray-200 dark:border-gray-700">
        <button type="button"
            class="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-brand-600 hover:text-brand-700 hover:bg-brand-50 dark:text-brand-400 dark:hover:bg-brand-500/10 rounded-lg transition-colors"
            (click)="showClientModal = false; showQuickClientRegister = true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
            </svg>
            Nuevo cliente
        </button>
        <button type="button" (click)="showClientModal = false"
            class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cancelar
        </button>
    </div>

</app-modal>

<!-- ================================================================ -->
<!-- MODAL AGREGAR PRODUCTO -->
<!-- ================================================================ -->
<app-modal [isOpen]="showProductModal" [className]="'max-w-2xl p-6'" (close)="showProductModal = false">

    <div class="mb-5">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Agregar producto</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Buscar producto por SKU / nombre</p>
    </div>

    <!-- BUSCADOR -->
    <div class="mb-4">
        <div class="relative">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>
            <input type="text" [(ngModel)]="productSearchTerm" (input)="searchProducts()"
                placeholder="Ej: MM-EST-0001 / Baranda / Tolva"
                class="w-full pl-9 pr-4 py-2.5 rounded-lg border border-gray-300 bg-white text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20 dark:bg-gray-900 dark:border-gray-700 dark:text-white dark:placeholder:text-gray-500"
                autofocus>
        </div>
    </div>

    <!-- RESULTADOS -->
    <div class="max-h-95 overflow-y-auto border border-gray-200 rounded-lg dark:border-gray-700">

        @if (loadingProducts) {
        <div class="py-10 text-center text-gray-400">
            <svg class="w-10 h-10 mx-auto mb-2 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            <p class="text-sm">Cargando productos...</p>
        </div>
        } @else if (productResults.length === 0) {
        <div class="py-10 text-center text-gray-400">
            <svg class="w-10 h-10 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
            <p class="text-sm">{{ productSearchTerm ? 'No se encontraron productos' : 'Sin productos disponibles' }}</p>
        </div>
        } @else {
        <div class="divide-y divide-gray-100 dark:divide-gray-700">
            @for (product of pagedProductResults; track product.id) {
            <div class="flex items-center justify-between px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer transition-colors"
                (click)="addProduct(product)">
                <div class="flex-1 min-w-0">
                    <p class="text-sm font-semibold text-gray-800 dark:text-white truncate">
                        {{ product.sku }} — {{ product.name }}
                    </p>
                    <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5 flex items-center gap-2">
                        {{ product.categoryName }}
                        @if (product.detractionCode) {
                        <span class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-400">
                            Det. {{ product.detractionCode }}
                        </span>
                        }
                    </p>
                </div>
                <span class="ml-4 text-sm font-semibold text-gray-700 dark:text-gray-300 whitespace-nowrap">
                    {{ currencySymbol }} {{ (currencyCode === 'USD' ? (product.salePriceUsd ?? 0) : (product.salePricePen ?? 0)) | number:'1.2-2' }}
                </span>
            </div>
            }
        </div>
        }

    </div>

    <!-- PAGINACIÓN -->
    @if (productResults.length > productPageSize) {
    <div class="flex items-center justify-between mt-3 px-1">
        <p class="text-xs text-gray-500 dark:text-gray-400">
            {{ (productCurrentPage - 1) * productPageSize + 1 }}–{{ productPageEnd }} de {{ productResults.length }}
        </p>
        <div class="flex gap-1">
            <button type="button" [disabled]="productCurrentPage === 1" (click)="productPrevPage()"
                class="px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <span class="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300">{{ productCurrentPage }} /
                {{ productTotalPages }}</span>
            <button type="button" [disabled]="productCurrentPage === productTotalPages" (click)="productNextPage()"
                class="px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
    </div>
    }

    <!-- FOOTER -->
    <div class="flex justify-between mt-5 pt-4 border-t border-gray-200 dark:border-gray-700">
        <button type="button"
            class="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-brand-600 hover:text-brand-700 hover:bg-brand-50 dark:text-brand-400 dark:hover:bg-brand-500/10 rounded-lg transition-colors"
            (click)="showProductModal = false; showQuickProductRegister = true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
            </svg>
            Nuevo producto
        </button>
        <button type="button" (click)="showProductModal = false"
            class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cancelar
        </button>
    </div>

</app-modal>

<!-- ================================================================ -->
<!-- MODAL AGREGAR SERVICIO -->
<!-- ================================================================ -->
<app-modal [isOpen]="showServiceModal" [className]="'max-w-2xl p-6'" (close)="showServiceModal = false">

    <div class="mb-5">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Agregar servicio</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">Buscar servicio por SKU / nombre</p>
    </div>

    <!-- BUSCADOR -->
    <div class="mb-4">
        <div class="relative">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>
            <input type="text" [(ngModel)]="serviceSearchTerm" (input)="searchServices()"
                placeholder="Ej: SRV-FAB-0001 / Soldadura / Instalación"
                class="w-full pl-9 pr-4 py-2.5 rounded-lg border border-gray-300 bg-white text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/20 dark:bg-gray-900 dark:border-gray-700 dark:text-white dark:placeholder:text-gray-500"
                autofocus>
        </div>
    </div>

    <!-- RESULTADOS -->
    <div class="max-h-85 overflow-y-auto border border-gray-200 rounded-lg dark:border-gray-700">

        @if (loadingServices) {
        <div class="py-10 text-center text-gray-400">
            <svg class="w-10 h-10 mx-auto mb-2 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
            <p class="text-sm">Cargando servicios...</p>
        </div>
        } @else if (serviceResults.length === 0) {
        <div class="py-10 text-center text-gray-400">
            <svg class="w-10 h-10 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <p class="text-sm">{{ serviceSearchTerm ? 'No se encontraron servicios' : 'Sin servicios disponibles' }}</p>
        </div>
        } @else {
        <div class="divide-y divide-gray-100 dark:divide-gray-700">
            @for (service of pagedServiceResults; track service.id) {
            <div class="flex items-center justify-between px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-800/50 cursor-pointer transition-colors"
                (click)="addService(service)">
                <div class="flex-1 min-w-0">
                    <p class="text-sm font-semibold text-gray-800 dark:text-white truncate">
                        {{ service.sku }} — {{ service.name }}
                    </p>
                    <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5 flex items-center gap-2">
                        {{ service.serviceCategoryName }}
                        @if (service.detractionCode) {
                        <span class="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-400">
                            Det. {{ service.detractionCode }}
                        </span>
                        }
                    </p>
                </div>
                <span class="ml-4 text-sm font-semibold text-gray-700 dark:text-gray-300 whitespace-nowrap">
                    {{ currencySymbol }} {{ (currencyCode === 'USD' ? (service.priceUsd ?? 0) : (service.pricePen ?? 0)) | number:'1.2-2' }}
                </span>
            </div>
            }
        </div>
        }

    </div>

    <!-- PAGINACIÓN -->
    @if (serviceResults.length > servicePageSize) {
    <div class="flex items-center justify-between mt-3 px-1">
        <p class="text-xs text-gray-500 dark:text-gray-400">
            {{ (serviceCurrentPage - 1) * servicePageSize + 1 }}–{{ servicePageEnd }} de {{ serviceResults.length }}
        </p>
        <div class="flex gap-1">
            <button type="button" [disabled]="serviceCurrentPage === 1" (click)="servicePrevPage()"
                class="px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <span class="px-3 py-1.5 text-sm text-gray-600 dark:text-gray-300">{{ serviceCurrentPage }} /
                {{ serviceTotalPages }}</span>
            <button type="button" [disabled]="serviceCurrentPage === serviceTotalPages" (click)="serviceNextPage()"
                class="px-2.5 py-1.5 rounded-lg border border-gray-300 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed dark:border-gray-700 dark:text-gray-300">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
    </div>
    }

    <!-- LINK A SERVICIO RÁPIDO -->
    <p class="mt-4 text-xs text-gray-500 dark:text-gray-400">
        ¿No existe el servicio? Usa
        <button type="button"
            class="inline-flex items-center gap-1 text-yellow-600 dark:text-yellow-400 font-medium hover:underline"
            (click)="showServiceModal = false; openQuickServiceModal()">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                <path d="M13 3L4 14h8l-1 7 9-11h-8l1-7z" />
            </svg>
            Servicio rápido
        </button>
        para crearlo y agregarlo al instante.
    </p>

    <!-- FOOTER -->
    <div class="flex justify-between mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
        <button type="button"
            class="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-brand-600 hover:text-brand-700 hover:bg-brand-50 dark:text-brand-400 dark:hover:bg-brand-500/10 rounded-lg transition-colors"
            (click)="showServiceModal = false; showQuickServiceRegister = true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
            </svg>
            Nuevo servicio
        </button>
        <button type="button" (click)="showServiceModal = false"
            class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cancelar
        </button>
    </div>

</app-modal>

<!-- ================================================================ -->
<!-- MODAL SERVICIO RÁPIDO -->
<!-- ================================================================ -->
<app-modal [isOpen]="showQuickServiceModal" [className]="'max-w-lg p-6'" (close)="showQuickServiceModal = false">

    <div class="mb-5">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Servicio rápido</h3>
        <p class="text-sm text-gray-500 dark:text-gray-400">
            Agrega un servicio personalizado directo a esta venta.
        </p>
    </div>

    <div class="space-y-4">

        <div>
            <app-label>Nombre del servicio <span class="text-red-500">*</span></app-label>
            <app-input-field type="text" placeholder="Ej: Soldadura TIG inoxidable" [(value)]="quickServiceName">
            </app-input-field>
        </div>

        <div class="grid grid-cols-2 gap-4">
            <div>
                <app-label>Cantidad <span class="text-red-500">*</span></app-label>
                <app-input-field type="number" [step]="1" min="1" placeholder="1" [(value)]="quickServiceQuantity">
                </app-input-field>
            </div>
            <div>
                <app-label>Precio <span class="text-red-500">*</span></app-label>
                <app-input-field type="number" [step]="0.01" min="0" placeholder="Ej: 250.00" [(value)]="quickServicePrice">
                </app-input-field>
            </div>
        </div>

        <div>
            <app-label>Código sujeto a detracción</app-label>
            <app-select [options]="detractionCodeOptions" [loading]="loadingDetractionCodes"
                placeholder="Sin detracción" [(value)]="quickServiceDetractionId">
            </app-select>
        </div>

    </div>

    <!-- FOOTER -->
    <div class="flex justify-end gap-3 mt-6 pt-5 border-t border-gray-200 dark:border-gray-700">
        <button type="button" (click)="showQuickServiceModal = false"
            class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
            Cancelar
        </button>
        <button type="button" (click)="submitQuickService()" [disabled]="!quickServiceName.trim() || !quickServicePrice"
            class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-brand-500 hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            Crear y agregar
        </button>
    </div>

</app-modal>

<!-- ================================================================ -->
<!-- REGISTRO RÁPIDO: CLIENTE -->
<!-- ================================================================ -->
<app-quick-client-register
    [isOpen]="showQuickClientRegister"
    (onClose)="showQuickClientRegister = false"
    (onCreated)="onClientCreated($event)">
</app-quick-client-register>

<!-- ================================================================ -->
<!-- REGISTRO RÁPIDO: PRODUCTO -->
<!-- ================================================================ -->
<app-quick-product-register
    [isOpen]="showQuickProductRegister"
    (onClose)="showQuickProductRegister = false"
    (onCreated)="onProductCreated($event)">
</app-quick-product-register>

<!-- ================================================================ -->
<!-- REGISTRO RÁPIDO: SERVICIO -->
<!-- ================================================================ -->
<app-quick-service-register
    [isOpen]="showQuickServiceRegister"
    (onClose)="showQuickServiceRegister = false"
    (onCreated)="onServiceCreated($event)">
</app-quick-service-register>